import { take, call, put } from 'redux-saga/effects';
import {
  PATH_SECURITY_USERS
} from '../paths';
import {
  PASSWORD_RESET_REQUEST,
  CLEAR_ERROR
} from '../actions/constants';
import Auth, {
  Token,
  SENDING_REQUEST,
  REQUEST_ERROR,
} from '@defi/core-auth'

/**
 * Effect to handle authorization
 * @param  {string} password               The username of the user
 * @param  {string} passwordConfirmation   The password of the user
 * @param  {object} options                Options
 */
export function * reset({ username, newPassword }) {
  // We send an action that tells Redux we're sending a request
  yield put({ type: SENDING_REQUEST, sending: true });

  // We then try to log in the user
  try {
    let currentProfile = new Token().getProfile();
    let clientID = currentProfile.ClientId;   
    let response = yield call(Auth.resetPassword, username, newPassword, clientID);
      return response;
    
    
  } catch (error) {

    // If we get an error we send Redux the appropiate action and return
    yield put({ type: REQUEST_ERROR, error: [error.message] });
    return false;
  } finally {
    // When done, we tell Redux we're not in the middle of a request any more
    yield put({ type: SENDING_REQUEST, sending: false });
  }
}

/**
 * Expiration saga
 */
export function * ResetPasswordFlow() {
  // Because sagas are generators, doing `while (true)` doesn't block our program
  // Basically here we say "this saga is always listening for actions"
  while (true) {
    // And we're listening for `LOGIN_REQUEST` actions and destructuring its payload
    let request = yield take(PASSWORD_RESET_REQUEST);
    let { username, newPassword } = request.data;

    yield put({ type: CLEAR_ERROR });

    // Call the authorize for username/password
    let response = yield call(reset, { username, newPassword });

    // We send Redux appropiate actions
    if (!response.Success && response.Errors && response.Errors.length > 0) {
        yield put({ type: REQUEST_ERROR, error: response.Errors });
    }
    else {
        window.location = PATH_SECURITY_USERS;
    }

  }
}
